<template>
  <div class="animated fadeIn">
    <report-search-options :periodOption=false @search="onSearch"/>

    <b-card  v-if="visitorsData">
      <b-btn type="submit" @click="exportCSV" variant="success">Export all data</b-btn>
      <hr/>
      <ag-grid-vue class="ag-theme-balham"
        :gridOptions="gridOptions"
        :rowData="visitorsData"
        :pagination="true"
        :paginationPageSize="20"
        :suppressNoRowsOverlay="true"
        :floatingFilter="true"
        @gridReady="gridReady">
      </ag-grid-vue>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import {AgGridVue} from "ag-grid-vue"
  import ReportSearchOptions from './components/ReportSearchOptions'
  export default {
    components: {
      AgGridVue,
      ReportSearchOptions
    },

    data: function () {
      return {
        visitorsData: null,
        currentSearch: null,
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            minWidth: 120
          },
          columnDefs: [
           {headerName: 'Id Number', field: 'idNumber' },
           {headerName: 'Name', field: 'name'},
           {headerName: 'Mobile Number', field: 'mobileNumber'},
           {headerName: 'People Visited', field: 'peopleVisited'},
           {headerName: 'Visit Date', field: 'visitDate',   minWidth: 150},
           {headerName: 'Security Date', field: 'securityDate',   minWidth: 150},
           {headerName: 'Exit Date', field: 'exitDate',   minWidth: 150}

         ]
       }
      }
    },
    methods:{
      exportParams() {
        return {
          'fileName': 'Soamibabh_VisitorsInformation_'+ this.currentSearch.fromDate + '_'+ this.currentSearch.toDate,
          'columnKeys': ['idNumber', 'name', 'mobileNumber', 'peopleVisited', 'visitDate', 'securityDate', 'exitDate']
        }
      },
      exportCSV() {
        if(this.visitorsData != null && !this.isEmpty(this.visitorsData)){
            this.gridOptions.api.exportDataAsCsv(this.exportParams());
        }
        else{
          this.showErrorMsg({
            message: "No searched records found for export."
          });
        }

      },
      isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
      },
      onSearch(data) {
         this.currentSearch = data
         this.$store.dispatch('samadh/getEntryVisitors', data)
          .then(response => {
            this.visitorsData = response.data.data
            this.showSuccessMsg()
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            }
            else if (error.response.status == 422){
                this.showErrorMsg({
                  message: error.response.data.message
                });
            }
            else {
              this.showErrorMsg()
            }

          })

      },
      gridReady(){
         this.gridOptions.api.sizeColumnsToFit();
      },

    },

  }
</script>
